import React from 'react';
import { FaSearch, FaTimes } from 'react-icons/fa';
import { useTranslation } from '../../../context/LanguageContext';

const OrderFilters = ({ 
    filters, 
    onFilterChange, 
    onSearch, 
    onClear,
    isVisible 
}) => {
    const { t } = useTranslation();
    
    if (!isVisible) return null;

    return (
        <form onSubmit={onSearch} className="bg-white rounded-xl shadow-lg p-6 mb-6 transition-all duration-300">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <div className="col-span-1 md:col-span-2 lg:col-span-1">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t('admin.filters.start_date')}
                    </label>
                    <input
                        type="datetime-local"
                        name="start_datetime"
                        value={filters.start_datetime || ''}
                        onChange={onFilterChange}
                        className="w-full rounded-lg border-gray-300 focus:border-yellow-500 focus:ring-yellow-500"
                    />
                </div>
                <div className="col-span-1 md:col-span-2 lg:col-span-1">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t('admin.filters.end_date')}
                    </label>
                    <input
                        type="datetime-local"
                        name="end_datetime"
                        value={filters.end_datetime || ''}
                        onChange={onFilterChange}
                        className="w-full rounded-lg border-gray-300 focus:border-yellow-500 focus:ring-yellow-500"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t('admin.filters.order_type')}
                    </label>
                    <select
                        name="order_type"
                        value={filters.order_type}
                        onChange={onFilterChange}
                        className="w-full rounded-lg border-gray-300 focus:border-yellow-500 focus:ring-yellow-500"
                    >
                        <option value="">{t('admin.filters.all_methods')}</option>
                        <option value="cash">{t('admin.filters.cash')}</option>
                        <option value="card">{t('admin.filters.card')}</option>
                    </select>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t('admin.filters.status')}
                    </label>
                    <select
                        name="status"
                        value={filters.status}
                        onChange={onFilterChange}
                        className="w-full rounded-lg border-gray-300 focus:border-yellow-500 focus:ring-yellow-500"
                    >
                        <option value="">{t('admin.filters.all')}</option>
                        <option value="returned">{t('admin.filters.returned')}</option>
                    </select>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t('admin.filters.order_number')}
                    </label>
                    <div className="relative">
                        <input
                            type="text"
                            name="order_number"
                            value={filters.order_number}
                            onChange={onFilterChange}
                            placeholder={t('admin.filters.search_by_order_number')}
                            className="w-full rounded-lg border-gray-300 focus:border-yellow-500 focus:ring-yellow-500 pl-10"
                        />
                        <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                    </div>
                </div>
            </div>
            <div className="mt-4 flex justify-end gap-3">
                <button
                    type="button"
                    onClick={onClear}
                    className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-all duration-200 flex items-center gap-2"
                >
                    <FaTimes />
                    {t('admin.filters.clear_filters')}
                </button>
                <button
                    type="submit"
                    className="px-4 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600
                        transform hover:scale-105 transition-all duration-200 flex items-center gap-2"
                >
                    <FaSearch />
                    {t('admin.filters.search_orders')}
                </button>
            </div>
        </form>
    );
};

export default OrderFilters;
